document.addEventListener('DOMContentLoaded', function() {
  const textBlocks = document.querySelectorAll('#shopify-section-template--28842901176665__carousel_V9jr9L .text-block, #shopify-section-template--28842901176665__carousel_V9jr9L p');
  const maxChars = 200;

  textBlocks.forEach(block => {
    const originalText = block.textContent.trim();
    
    if (originalText.length > maxChars) {
      const truncated = originalText.substring(0, maxChars);
      const wrapper = document.createElement('div');
      
      wrapper.innerHTML = `
        <span class="short-text">${truncated}... </span>
        <span class="full-text" style="display:none;">${originalText} </span>
        <button class="read-more-btn">Mehr lesen</button>
      `;
      
      block.textContent = '';
      block.appendChild(wrapper);
      
      const btn = wrapper.querySelector('.read-more-btn');
      const shortText = wrapper.querySelector('.short-text');
      const fullText = wrapper.querySelector('.full-text');
      
      btn.addEventListener('click', function() {
        if (fullText.style.display === 'none') {
          shortText.style.display = 'none';
          fullText.style.display = 'inline';
          btn.textContent = 'Weniger anzeigen';
        } else {
          shortText.style.display = 'inline';
          fullText.style.display = 'none';
          btn.textContent = 'Mehr lesen';
        }
      });
    }
  });
});
